import { render, staticRenderFns } from "./DolligoTop.vue?vue&type=template&id=1dcbdf85&"
import script from "./DolligoTop.vue?vue&type=script&lang=js&"
export * from "./DolligoTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports